module.exports = __webpack_public_path__ + "img/Varenstraat-voor.1618c9ed.jpg";